
export const venuesDetailData = [
  {
    name: 'TOKYO LIVE HOUSE SHIBUYA',
    area: '渋谷区',
    address: '渋谷区道玄坂2-10-12',
    capacity: '300名',
    phone: '03-3461-XXXX',
    genre: 'ロック / ポップス / ジャズ',
    icon: 'ri-building-2-line',
    description: '渋谷道玄坂に位置する収容300名のライブハウス。最新音響設備とバーを併設し、ジャンルを問わず幅広い公演に対応。駅徒歩3分のアクセスの良さも魅力です。',
    links: [
      { label: '公式サイト', url: 'https://example.com/shibuya-livehouse', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_shibuya', icon: 'ri-twitter-x-line' },
      { label: '予約ページ', url: 'https://example.com/shibuya-livehouse/reserve', icon: 'ri-calendar-check-line' },
    ],
  },
  {
    name: 'SHINJUKU MUSIC CLUB',
    area: '新宿区',
    address: '新宿区歌舞伎町1-15-8',
    capacity: '250名',
    phone: '03-3209-XXXX',
    genre: 'ロック / エレクトロニカ / ヒップホップ',
    icon: 'ri-music-2-line',
    description: '新宿歌舞伎町エリアの収容250名の音楽クラブ。プロ仕様の照明設備とリハーサル室を完備。深夜営業にも対応し、多様な公演スタイルを受け入れています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/shinjuku-music', icon: 'ri-global-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_shinjuku', icon: 'ri-instagram-line' },
      { label: '予約ページ', url: 'https://example.com/shinjuku-music/reserve', icon: 'ri-calendar-check-line' },
    ],
  },
  {
    name: 'ROPPONGI SOUND STAGE',
    area: '港区',
    address: '港区六本木3-8-15',
    capacity: '400名',
    phone: '03-3401-XXXX',
    genre: 'ジャズ / クラシック / ワールドミュージック',
    icon: 'ri-surround-sound-line',
    description: '六本木の大型ステージを備えた収容400名の会場。VIPラウンジと駐車場を完備し、大規模イベントやプレミアム公演に最適な環境を提供しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/roppongi-sound', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_roppongi', icon: 'ri-twitter-x-line' },
      { label: 'Facebook', url: 'https://facebook.com/example_roppongi', icon: 'ri-facebook-line' },
    ],
  },
  {
    name: 'IKEBUKURO LIVE SPOT',
    area: '豊島区',
    address: '豊島区西池袋1-20-5',
    capacity: '200名',
    phone: '03-3981-XXXX',
    genre: 'アコースティック / フォーク / インディーズ',
    icon: 'ri-store-2-line',
    description: '池袋西口エリアの収容200名のアットホームな会場。カフェ併設で初心者アーティストも歓迎。地域密着型のイベントを数多く開催しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/ikebukuro-live', icon: 'ri-global-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_ikebukuro', icon: 'ri-instagram-line' },
      { label: '予約ページ', url: 'https://example.com/ikebukuro-live/reserve', icon: 'ri-calendar-check-line' },
    ],
  },
  {
    name: 'HARAJUKU MUSIC BOX',
    area: '渋谷区',
    address: '渋谷区神宮前4-12-10',
    capacity: '180名',
    phone: '03-3470-XXXX',
    genre: 'ポップス / R&B / シンガーソングライター',
    icon: 'ri-disc-line',
    description: '原宿・神宮前に位置する収容180名のスタイリッシュな会場。若手アーティスト支援に力を入れ、レコーディング設備とカフェバーを併設しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/harajuku-music', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_harajuku', icon: 'ri-twitter-x-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_harajuku', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'AKIHABARA SOUND HALL',
    area: '千代田区',
    address: '千代田区外神田3-5-12',
    capacity: '350名',
    phone: '03-3253-XXXX',
    genre: 'アニソン / ボカロ / エレクトロニカ',
    icon: 'ri-headphone-line',
    description: '秋葉原の収容350名の多目的ホール。最新の配信設備を備え、オンライン・オフライン両対応。楽器レンタルサービスも充実しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/akihabara-sound', icon: 'ri-global-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_akihabara', icon: 'ri-youtube-line' },
      { label: '予約ページ', url: 'https://example.com/akihabara-sound/reserve', icon: 'ri-calendar-check-line' },
    ],
  },
  {
    name: 'SHIMOKITAZAWA GARAGE',
    area: '世田谷区',
    address: '世田谷区北沢2-14-7',
    capacity: '150名',
    phone: '03-3414-XXXX',
    genre: 'パンク / オルタナティブ / インディーロック',
    icon: 'ri-guitar-line',
    description: '下北沢の老舗ライブハウス。収容150名のコンパクトな空間で、アーティストと観客の距離が近い臨場感あふれるライブ体験を提供しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/shimokita-garage', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_shimokita', icon: 'ri-twitter-x-line' },
      { label: '予約ページ', url: 'https://example.com/shimokita-garage/reserve', icon: 'ri-calendar-check-line' },
    ],
  },
  {
    name: 'KOENJI HIGH',
    area: '杉並区',
    address: '杉並区高円寺南3-22-1',
    capacity: '220名',
    phone: '03-3312-XXXX',
    genre: 'レゲエ / ダブ / ワールドミュージック',
    icon: 'ri-equalizer-line',
    description: '高円寺の多文化対応ライブハウス。収容220名で、国内外のアーティストが出演。フードコートを併設し、音楽とグルメを同時に楽しめます。',
    links: [
      { label: '公式サイト', url: 'https://example.com/koenji-high', icon: 'ri-global-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_koenji', icon: 'ri-instagram-line' },
      { label: 'Facebook', url: 'https://facebook.com/example_koenji', icon: 'ri-facebook-line' },
    ],
  },
];
